import type { ComponentProps } from 'react';
import React from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';

import { BodyText } from '../../../Text';
import { ModalRow } from '../ModalRow';

import type { PaletteProps } from '../../Modal.types';

export const ModalBodyText = (props: ComponentProps<typeof BodyText> & PaletteProps) => {
  const { children, ...restProps } = props;

  return (
    <ModalRow>
      <BodyText sizeMatch={['14', '16']} style={styles.bodyText} {...restProps}>
        {children}
      </BodyText>
    </ModalRow>
  );
};

// ─── Styles ────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  bodyText: {
    paddingBottom: theme.spacing['6'],
  },
});
